import * as Yup from "yup";

const stringLengths = {
  min: 1,
  titleMax: 128,
  headingMax: 256,
  bodyMax: 2048,
  callToActionMax: 64,
  destinationUrlMax: 2048,
};

export const msTeamsMessageSchema = Yup.object().shape({
  headline: Yup.string()
    .trim()
    .required("Heading is required")
    .min(stringLengths.min, `Heading must have at least ${stringLengths.min} characters`)
    .max(stringLengths.headingMax, `Heading cannot exceed ${stringLengths.headingMax} characters`),
  body: Yup.string()
    .required("Body is required")
    .min(stringLengths.min, `Body must have at least ${stringLengths.min} characters`)
    .max(stringLengths.bodyMax, `Body cannot exceed ${stringLengths.bodyMax} characters`),
  callToAction: Yup.string()
    .required("Call to Action is required")
    .min(stringLengths.min, `Call to Action must have at least ${stringLengths.min} characters`)
    .max(stringLengths.callToActionMax, `Call to Action cannot exceed ${stringLengths.callToActionMax} characters`),
  destinationUrl: Yup.string()
    .required("Destination URL is required")
    .min(stringLengths.min, `Destination URL must have at least ${stringLengths.min} characters`)
    .max(
      stringLengths.destinationUrlMax,
      `Destination URL cannot exceed ${stringLengths.destinationUrlMax} characters`,
    ),
  imageUrl: Yup.string().required("Image Cap is required"),
});
